<template>
    <div id="MyExtension">
        <div class="spreadUser_wrap">
            <div class="spread_top_wrap">
                <div class="top_item">
                    <div class="item_title">
                        <img src="@/assets/images/MyExtension/my.png" alt="">
                        我的推广链接：
                    </div>
                    <div class="item_c">
                        <span>{{ Invite_connect }}</span>
                        <div class="icon_c">
                            <span v-clipboard:copy="Invite_connect" v-clipboard:success="onCopy"
                                v-clipboard:error="onError">
                            </span>
                        </div>
                    </div>

                </div>
                <div class="top_item">
                    <div class="item_title">
                        <img src="@/assets/images/MyExtension/2.png" alt="">
                        我的邀请码：
                    </div>
                    <div class="item_c" style="width: 504px;">
                        <span>{{ invite_code }}</span>
                        <div class="icon_c">
                            <span v-clipboard:copy="invite_code" v-clipboard:success="onCopy" v-clipboard:error="onError">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spread_header">
                <div class="spread_header_l">
                </div>

                <div class="spread_header_c">
                    我的推广
                </div>
                <div class="spread_header_r">
                </div>
            </div>
            <div class="spread_content">
                <div class="info_title">
                    <p>奖励等级</p>
                    <p>成功邀请人数</p>
                    <p>奖金比例</p>
                    <p>累计收益</p>
                </div>
                <div class="info_content">
                    <p class="c1">{{ user.promotion_level }}</p>
                    <p class="c2">{{ invitation }}</p>
                    <p class="c3">{{ rebate }}%</p>
                    <p class="c4">{{ gain }}</p>
                </div>
                <div class="rule">
                    <img src="@/assets/images/MyExtension/spread_rule.png" alt="">
                </div>

            </div>
            <div class="spread_header">
                <div class="spread_header_l">
                </div>

                <div class="spread_header_c">
                    推广明细
                </div>
                <div class="spread_header_r">
                </div>
            </div>
            <div class="spread_content">
                <div class="info_title">
                    <p>邀请用户</p>
                    <p>邀请奖励</p>
                    <p>充值金额</p>
                </div>
                <div class="info_content" v-for="(item, index) in UserList" :key="index">
                    <p class="c2">{{ item.name }}</p>
                    <p class="c2">{{ item.bean }}</p>
                    <p class="c4">{{ item.charge_bean }}</p>
                </div>
            </div>
            <div class="PageNum">
                <el-pagination background layout="prev, pager, next" @current-change="HandleCurrentChange"
                    :page-size="per_page" :total="total">
                </el-pagination>
            </div>
        </div>


    </div>
</template>

<script>
import {
    Promote,
    Be_inviter,
} from '@/network/api.js'
import {
    mapState
} from 'vuex'
export default {
    name: 'MyExtension',
    data() {
        return {
            Invite_connect: '', ///推广链接
            invite_code: '',    ///我的邀请码
            invitation: '',     ///成功邀请人数
            rebate: '',         ///奖金比例
            gain: '',           //累计收益

            UserList: [],       ///邀请的用户列表
            total: 0,       ///记录条数
			per_page: 5,    ///一页几条
        }
    },
    created() {
        this.GetBeInviter(1);
        this.GetPromote();
    },
    methods: {
        HandleCurrentChange(val) {
            this.GetBeInviter(val)
		},
        GetBeInviter(val) {
            //this.loadingShow = true
            Be_inviter(val).then((res) => {
                this.UserList = res.data.data[0].data;
                this.total = res.data.data[0].total
                this.per_page = res.data.data[0].per_page
            })
        },

        GetPromote() {
            Promote().then((res) => {
                // this.welfare_key_total = res.data.data.user.welfare_key_total
                // this.welfare_promotion = res.data.data.welfare_promotion
                this.invite_code = res.data.data.user.invite_code;
                this.Invite_connect = '//www.999skins.com/?ref=' + res.data.data.user.invite_code;

                // this.GradeList = res.data.data.list
                // this.describe = res.data.data.user.promotion.description
                this.invitation = res.data.data.user.be_invite_number;
                this.rebate = res.data.data.user.promotion.rebate;
                this.gain = res.data.data.user.gain;


            })
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError() {
            this.$message({
                message: '复制失败',
                type: 'error'
            })
        }
    },
    computed: {
        ...mapState([
            'user'
        ])
    },

}
</script>

<style lang="scss">
#MyExtension {
    .PageNum {
        width: 100%;
        text-align: center;
        margin: 20px 0;

        li {
            background: #111111 !important;

            &.active {
                background: #4854c9 !important;
            }

            &:hover {
                color: #fff !important;
            }
        }

        .btn-prev,
        .btn-next {
            background: #111111;
        }
    }

    .spreadUser_wrap {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-top: 3px;
        width: 100%;
        min-height: 500px;
        padding-bottom: 50px;

        .spread_top_wrap {
            display: flex;
            width: 100%;
            justify-content: space-between;
            padding: 45px 50px 50px;
            box-sizing: border-box;
            background: #0e0f1e;
            box-shadow: 0 24px 31px #0f101fb5;

            .top_item {
                display: flex;
                flex-direction: column;

                .item_title {
                    display: flex;
                    color: #b8b9cc;
                    font-size: 19px;
                }

                .item_c {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: #fff;
                    font-size: 14px;
                    background: #131528;
                    padding: 0 25px;
                    height: 76px;
                    margin-top: 16px;
                    width: 756px;
                    box-sizing: border-box;

                    .icon_c {
                        display: inline-block;
                        vertical-align: middle;
                        fill: currentColor;
                        position: relative;
                        top: 0px;
                        width: 22px;
                        height: 22px;
                        background: url(../../../assets/images/MyExtension/1.png) center no-repeat;

                    }
                }
            }
        }

        .spread_header {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            color: #8488a6;
            font-size: 16px;

            .spread_header_l {
                flex: 1;
            }

            .spread_header_c {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 197px;
                height: 105px;
                background: url(../../../assets/images/MyExtension/header_bg.png) center no-repeat;
                background-size: 100% 100%;
                color: #fff;
                font-size: 24px;
            }

            .spread_header_r {
                display: flex;
                flex: 1;
                justify-content: flex-end;
            }
        }

        .spread_content {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            width: 100%;

            .info_title {
                display: flex;
                width: 100%;
                background: #111324;
                color: #5d5f72;
                font-size: 13px;
                font-weight: 700;
                align-items: center;
                box-sizing: border-box;
                padding: 0 30px;
                height: 66px;

                p {
                    flex: 2;

                    &:last-child {
                        flex: 1;
                    }
                }
            }

            .info_content {
                display: flex;
                width: 100%;
                background: #131528;
                align-items: center;
                box-sizing: border-box;
                padding: 0 30px;
                height: 56px;

                p {
                    flex: 2;

                    &:last-child {
                        flex: 1;
                    }
                }

                .c1 {
                    color: #6a77ff;
                    font-family: "Oxanium";
                    font-size: 15px;
                    font-weight: 500;
                }

                .c2 {
                    color: #fff;
                    font-family: "Oxanium";
                    font-size: 15px;
                    font-weight: 500;
                }

                .c3 {
                    color: #75dc9e;
                    font-family: "Oxanium";
                    font-size: 15px;
                    font-weight: 500;
                }

                .c4 {
                    color: #FFD077;
                    font-family: "Oxanium";
                    font-size: 15px;
                    font-weight: 500;
                }

            }

            .rule {}


        }

    }
}
</style>